import currentUserPreload from "shared/current-user-preload"
import currentUserSelect from "shared/current-user-select"
import Devise from "@kaspernj/api-maker/build/devise"
import {User} from "models"

export {currentUserSelect as select}
export default async function usersUpdateSession(userId) {
  if (userId) {
    const currentUserWithRelationships = await User
      .ransack({id_eq: userId})
      .preload(currentUserPreload)
      .select(currentUserSelect)
      .first()

    Devise.updateSession(currentUserWithRelationships, {scope: "user"})
    Devise.events().emit("onDeviseSignIn")
  } else {
    Devise.updateSession(null, {scope: "user"})
    Devise.events().emit("onDeviseSignOut")
  }
}
